var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-touch', {
    on: {
      "tap": _vm.tap
    }
  }, [_c('a', {
    staticClass: "t-page-link",
    style: _vm.style,
    attrs: {
      "href": _vm.href,
      "rel": _vm.linkRel,
      "target": _vm.target,
      "title": _vm.linkTitle,
      "draggable": "false"
    },
    on: {
      "click": _vm.click,
      "dragstart": _vm.dragstart
    }
  }, [_vm.anchorText ? _c('span', [_vm._v(_vm._s(_vm.anchorText))]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }